import { render, staticRenderFns } from "./AtRiskAccounts.vue?vue&type=template&id=1069b23e&scoped=true"
import script from "./AtRiskAccounts.vue?vue&type=script&lang=js"
export * from "./AtRiskAccounts.vue?vue&type=script&lang=js"
import style0 from "./AtRiskAccounts.vue?vue&type=style&index=0&id=1069b23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1069b23e",
  null
  
)

export default component.exports